



























import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../lib/util'
import AbpBase from '../../lib/abpbase'
import WasteType from '../../store/entities/wastetype'
@Component
export default class CreateWasteType extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    wastetype:WasteType=new WasteType();
    
    save(){
        (this.$refs.wastetypeForm as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'wastetype/create',
                    data:this.wastetype
                });
                (this.$refs.wastetypeForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.wastetypeForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    validatePassCheck = (rule:any, value:any, callback:any) => {
        if (!value) {
            callback(new Error(this.L('ConfirmPasswordMsg')));
           
            callback(new Error(this.L('ConfirmPasswordNotMatch')));
        } else {
            callback();
        }
    };
    wastetypeRule={
        
        name:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('WasteTypeName')),trigger: 'blur'}],
        
    }
}
